import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Grid,
} from "@mui/material";
import { Genders, Prefixes } from "../Utility/Constants";

const NewPatientDialog = ({ open, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    prefix: "",
    firstName: "",
    lastName: "",
    gender: "",
    dateOfBirth: "",
    age: "",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "age") {
      const age = parseInt(value, 10);
      if (!isNaN(age)) {
        const today = new Date();
        const birthDate = new Date(
          today.getFullYear() - age,
          today.getMonth(),
          today.getDate()
        );
        const dobStr = birthDate.toISOString().split("T")[0];

        setFormData((prev) => ({
          ...prev,
          age: value,
          dateOfBirth: dobStr,
        }));
      } else {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSave = async () => {
    await onSave(formData);
    setFormData({
      prefix: "",
      firstName: "",
      lastName: "",
      gender: "",
      dateOfBirth: "",
      age: "",
      phone: "",
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add New Patient</DialogTitle>
      <DialogContent dividers>
        <TextField
          select
          label="Prefix"
          name="prefix"
          value={formData.prefix}
          onChange={handleChange}
          fullWidth
          margin="normal"
        >
          {Prefixes.map((prefix) => (
            <MenuItem key={prefix} value={prefix}>
              {prefix}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="First Name"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Last Name"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          select
          label="Gender"
          name="gender"
          value={formData.gender}
          onChange={handleChange}
          fullWidth
          margin="normal"
        >
          {Genders.map((gender) => (
            <MenuItem key={gender} value={gender}>
              {gender}
            </MenuItem>
          ))}
        </TextField>

        {/* DOB and Age in Two Columns */}
        <Grid container spacing={2} marginTop={0}>
          <Grid item xs={6}>
            <TextField
              label="Date of Birth"
              name="dateOfBirth"
              type="date"
              value={formData.dateOfBirth}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Enter Age"
              name="age"
              type="number"
              value={formData.age}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
        </Grid>

        <TextField
          label="Mobile Number"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewPatientDialog;